import { render, staticRenderFns } from "./imgIndex.vue?vue&type=template&id=20ba8606"
import script from "./imgIndex.vue?vue&type=script&lang=js"
export * from "./imgIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ba8606')) {
      api.createRecord('20ba8606', component.options)
    } else {
      api.reload('20ba8606', component.options)
    }
    module.hot.accept("./imgIndex.vue?vue&type=template&id=20ba8606", function () {
      api.rerender('20ba8606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/imgIndex.vue"
export default component.exports